module.exports = "images/4ans.710e19c1.png";